import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddProjectComponent } from "./add-project/add-project.component";
import { AddRotationComponent } from "./add-rotation/add-rotation.component";
import { AnnouncementComponent } from "./announcement/announcement.component";
import { AvailabilityRequestComponent } from "./availability-request/availability-request.component";
import { BlockRequestsListComponent } from "./block-requests-list/block-requests-list.component";
import { CampaignsComponent } from "./campaigns/campaigns.component";
import { CliComponent } from "./cli/cli.component";
import { ContractGenerateComponent } from "./contract-generate/contract-generate.component";
import { DailyReportComponent } from "./daily-report/daily-report.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DuplicatedLeadsComponent } from "./duplicated-leads/duplicated-leads.component";
import { EoiTableComponent } from "./eois/eoi-table/eoi-table.component";
import { EoiComponent } from "./eois/eoi/eoi.component";
import { FinanceAccountsComponent } from "./finance-accounts/finance-accounts.component";
import { FinanceAddAccountComponent } from "./finance-add-account/finance-add-account.component";
import { FinanceAddTransactionComponent } from "./finance-add-transaction/finance-add-transaction.component";
import { FinanceBalanceSheetComponent } from "./finance-balance-sheet/finance-balance-sheet.component";
import { FinanceTransactionComponent } from "./finance-transaction/finance-transaction.component";
import { FinancialReportComponent } from "./financial-report/financial-report.component";
import { AddLeadGuard } from "./guards/addLead.guard";
import { AddProjectGuard } from "./guards/addProject.guard";
import { AuthGuard } from "./guards/authguard.guard";
import { LeadsGuard } from "./guards/leads.guard";
import { LoginGuard } from "./guards/login.guard";
import { PaymentGeneratorGuard } from "./guards/paymentGenerator.guard";
import { CanEnterProjectsTab } from "./guards/projects.guard";
import { ReservationsGuard } from "./guards/reservations.guard";
import { SettingTabGuard } from "./guards/settingsTab.guard";
import { WalletGuard } from "./guards/wallet.guard";
import { ImportUnitsComponent } from "./import-units/import-units.component";
import { AddLeadComponent } from "./lead/addLead/addlead.component";
import { LeadsComponent } from "./lead/dashboard/lead.component";
import { LoginComponent } from "./login/login.component";
import { LogsComponent } from "./logs/logs.component";
import { MainComponent } from "./main/main.component";
import { MarketingReportsComponent } from "./marketing-reports/marketing-reports.component";
import { MarketingComponent } from "./marketing/marketing.component";
import { MasterPlanComponent } from "./master-plan/master-plan.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { PaymentCollectionsComponent } from "./payment-collections/payment-collections.component";
import { PaymentGeneratorComponent } from "./payment-generator/payment-generator.component";
import { PriceControlComponent } from "./price-control/price-control.component";
import { PriceControllerRequestsComponent } from "./price-controller-requests/price-controller-requests.component";
import { ProfileComponent } from "./profile/profile.component";
import { ProjectsComponent } from "./projects/projects.component";
import { ReminderComponent } from "./reminder/reminder.component";
import { ReportsComponent } from "./reports/reports.component";
import { WalletComponent } from "./reports/wallet/wallet.component";
import { ReservationViewComponent } from "./reservation-view/reservation-view.component";
import { AddreservationComponent } from "./reservation/addreservation/addreservation.component";
import { ReservationComponent } from "./reservation/reservation.component";
import { RotationLogsComponent } from "./rotation-logs/rotation-logs.component";
import { RotationComponent } from "./rotation/rotation.component";
import { TrashLeadsComponent } from "./trash-leads/trash-leads.component";
import { UnitViewComponent } from "./unit-view/unit-view.component";
import { UnitsComponent } from "./units/units.component";
import { UploadLayoutComponent } from "./upload-layout/upload-layout.component";

import { AddTicketComponent } from "./add-ticket/add-ticket.component";
import { BankChequeListingComponent } from "./bank-cheque-listing/bank-cheque-listing.component";
import { ClientStatementsComponent } from "./client-statements/client-statements.component";
import { ColdCallsSheetsComponent } from "./cold-calls-sheets/cold-calls-sheets.component";
import { CustomersBirthdayComponent } from "./customers-birthday/customers-birthday.component";
import { AddEoiComponent } from "./eois/add-eoi/add-eoi.component";
import { EoiViewComponent } from "./eois/eoi-view/eoi-view.component";
import { FinesListComponent } from "./fines-list/fines-list.component";
import { AddHoldComponent } from "./hold-module/add-hold/add-hold.component";
import { HoldDetailsComponent } from "./hold-module/hold-details/hold-details.component";
import { HoldListComponent } from "./hold-module/hold-list/hold-list.component";
import { ListingLeadsByActivitesComponent } from "./listing-leads-by-activites/listing-leads-by-activites.component";
import { MailBuilderComponent } from "./mail-builder/mail-builder.component";
import { PaymentCollectionViewComponent } from "./payment-collection-view/payment-collection-view.component";
import { PrintChequeComponent } from "./print-cheque/print-cheque.component";
import { RotationsListComponent } from "./rotations-list/rotations-list.component";
import { TicketViewComponent } from "./ticket-view/ticket-view.component";
import { TicketsComponent } from "./tickets/tickets.component";
import { ViewClientStatementsComponent } from "./view-client-statements/view-client-statements.component";
import { BrokersListComponent } from "./brokers-list/brokers-list.component";
import { BuildComponent } from "./build/build.component";
import { ErpLogsComponent } from "./erp-logs/erp-logs.component";
import { BrokersIncentivesComponent } from "./brokers-incentives/brokers-incentives.component";
import { BrokersIncentivesManageComponent } from "./brokers-incentives-manage/brokers-incentives-manage.component";
import { BrokerWalletComponent } from "./broker-wallet/broker-wallet.component";
import { MarketingReportComponent } from "./marketing-report/marketing-report.component";
import { InventoryReportComponent } from "./inventory-report/inventory-report.component";
import { AllPagesComponent } from "./all-pages/all-pages.component";
import { CashFlowReportComponent } from "./cash-flow-report/cash-flow-report.component";
import { CeoReportsComponent } from "./ceo-reports/ceo-reports.component";
import { UploadProjectOfferImagesComponent } from "./upload-project-offer-images/upload-project-offer-images.component";
import { CampaignViewerUserGuard } from "./guards/campaign-viewer-user.guard";
import { JsonEditorModalComponent } from "./json-editor-modal/json-editor-modal.component";
import { InvalidLeadsComponent } from "./invalid-leads/invalid-leads.component";
import { BrokersComponent } from "./main-settings/brokers/brokers.component";
import { AddBrokerComponent } from "./main-settings/brokers/add-broker/add-broker.component";
import { TodosComponent } from "./todos/todos.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "pages",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "pages",
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "leads",
        component: LeadsComponent,
        canActivate: [LeadsGuard, CampaignViewerUserGuard],
      },
      {
        path: "leads/:id",
        component: LeadsComponent,
        canActivate: [LeadsGuard, CampaignViewerUserGuard],
      },
      {
        path: "todos",
        component: TodosComponent,
      },
      {
        path: "invalid-leads",
        component: InvalidLeadsComponent,
        canActivate: [LeadsGuard],
      },
      {
        path: "clients-statements",
        component: ClientStatementsComponent,
      },
      {
        path: "ERP-logs",
        component: ErpLogsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "edit-erp-log-data/:id",
        component: JsonEditorModalComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "clients-statements",
        component: ClientStatementsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "clients-statements/:id",
        component: ViewClientStatementsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "leads-listing-activites",
        component: ListingLeadsByActivitesComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "duplicated-leads",
        component: DuplicatedLeadsComponent,
        canActivate: [LeadsGuard, CampaignViewerUserGuard],
      },
      {
        path: "trash-leads",
        component: TrashLeadsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "eoi/:id",
        component: EoiComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "eoi-table",
        component: EoiTableComponent,
        canActivate: [CampaignViewerUserGuard],
        // canActivate: [EoisGuard],
      },
      {
        path: "eoi-view/:id",
        component: EoiViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "add-hold/:id",
        component: AddHoldComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "hold-list",
        component: HoldListComponent,
        canActivate: [CampaignViewerUserGuard],
        // canActivate: [EoisGuard],
      },
      {
        path: "hold-details/:id",
        component: HoldDetailsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "addLead/:id",
        component: AddLeadComponent,
        canActivate: [AddLeadGuard, CampaignViewerUserGuard],
      },
      {
        path: "projects",
        component: ProjectsComponent,
        canActivate: [CanEnterProjectsTab, CampaignViewerUserGuard],
      },
      {
        path: "projects/import-units",
        component: ImportUnitsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "projects/upload-offer-images",
        component: UploadProjectOfferImagesComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "projects/units/:id",
        component: UnitsComponent,
        canActivate: [CanEnterProjectsTab, CampaignViewerUserGuard],
      },
      {
        path: "projects/buildings/:id",
        component: BuildComponent,
        canActivate: [CanEnterProjectsTab, CampaignViewerUserGuard],
      },
      {
        path: "projects/view-all-units",
        component: UnitsComponent,
        canActivate: [CanEnterProjectsTab, CampaignViewerUserGuard],
      },
      // {
      //   path: 'projects/view-all-units',
      //   component: AllUnitViewComponent,
      //   canActivate: [CanEnterProjectsTab]
      // },
      {
        path: "projects/block-requests-list",
        component: BlockRequestsListComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "settings",
        loadChildren: "./main-settings/main-settings.module#MainSettingsModule",
        canActivate: [CampaignViewerUserGuard],
        ///using this syntax due to error TS1323. check this for refrence
        //https://stackoverflow.com/questions/56375703/angular-8-lazy-loading-modules-error-ts1323-dynamic-import-is-only-supporte
      },
      {
        path: "reservations",
        component: ReservationComponent,
        canActivate: [ReservationsGuard, CampaignViewerUserGuard],
      },
      {
        path: "reservations/add/:id",
        component: AddreservationComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "projects/add/:id",
        component: AddProjectComponent,
        canActivate: [
          CanEnterProjectsTab,
          AddProjectGuard,
          CampaignViewerUserGuard,
        ],
      },
      {
        path: "payment-generator",
        component: PaymentGeneratorComponent,
        canActivate: [PaymentGeneratorGuard, CampaignViewerUserGuard],
      },
      {
        path: "payment-collections",
        component: PaymentCollectionsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "payment-collections/:id",
        component: PaymentCollectionViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "fines-list",
        component: FinesListComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "projects/conrtact-generate",
        component: ContractGenerateComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "projects/view-unit",
        component: UnitViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "upload-layout",
        component: UploadLayoutComponent,
        canActivate: [SettingTabGuard, CampaignViewerUserGuard],
      },
      {
        path: "project/view-reservation",
        component: ReservationViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "project/view-reservation/:id",
        component: ReservationViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "profile",
        component: ProfileComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "finance/accounts",
        component: FinanceAccountsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "finance/accounts/add/:id",
        component: FinanceAddAccountComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "finance/balance-sheet",
        component: FinanceBalanceSheetComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "finance/transaction",
        component: FinanceTransactionComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "finance/transaction/add",
        component: FinanceAddTransactionComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "notifications",
        component: NotificationsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "marketing",
        component: MarketingComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "reports",
        component: ReportsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "cils",
        component: CliComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "availability-request",
        component: AvailabilityRequestComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "price-control",
        component: PriceControlComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "price-control/requests",
        component: PriceControllerRequestsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "master-plan",
        component: MasterPlanComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "wallet",
        component: WalletComponent,
        canActivate: [WalletGuard, CampaignViewerUserGuard],
      },
      {
        path: "broker-wallet",
        component: BrokerWalletComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "brokers",
        canActivate: [CampaignViewerUserGuard],
        children: [
          {
            path: "list",
            component: BrokersComponent,
          },
          {
            path: "add",
            component: AddBrokerComponent,
          },
          {
            path: "add/:id",
            component: AddBrokerComponent,
          },
          {
            path: "incentives",
            component: BrokersIncentivesComponent,
          },
          {
            path: "incentives/add",
            component: BrokersIncentivesManageComponent,
          },
          {
            path: "incentives/add/:id",
            component: BrokersIncentivesManageComponent,
          },
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full",
          },
        ],
      },
      {
        path: "announcement",
        component: AnnouncementComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "rotation",
        component: RotationComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "campaigns",
        component: CampaignsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "all-pages",
        component: AllPagesComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "rotation-logs",
        component: RotationLogsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "logs",
        component: LogsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "marketing-reports",
        component: MarketingReportsComponent,
      },
      {
        path: "reminder",
        component: ReminderComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "daily-report",
        component: DailyReportComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "marketing-report",
        component: MarketingReportComponent,
      },
      {
        path: "inventory-report",
        component: InventoryReportComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "financial-report",
        component: FinancialReportComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "cash-flow-report",
        component: CashFlowReportComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "ceo-report",
        component: CeoReportsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "rotation/add",
        component: AddRotationComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "rotations",
        component: RotationsListComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "bank-cheque-listing",
        component: BankChequeListingComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "print-cheque",
        component: PrintChequeComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "cold-calls",
        canActivate: [CampaignViewerUserGuard],
        children: [
          {
            path: "sheets",
            component: ColdCallsSheetsComponent,
          },
        ],
      },
      {
        path: "mail-builder",
        component: MailBuilderComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "add-eoi",
        component: AddEoiComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "add-ticket",
        // loadChildren: './main-settings/main-settings.module#MainSettingsModule'
        component: AddTicketComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "edit-ticket/:id",
        component: AddTicketComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "tickets",
        component: TicketsComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "view-ticket/:id",
        // loadChildren: './tickets/tickets.module#TicketsModule',
        component: TicketViewComponent,
        canActivate: [CampaignViewerUserGuard],
      },
      {
        path: "customers-birthday",
        component: CustomersBirthdayComponent,
        canActivate: [CampaignViewerUserGuard],
      },
    ],
  },
  {
    path: "**",
    redirectTo: "pages",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts